import { getSupabaseBrowserClient } from '@/lib/supabase/client';

/**
 * Initiates Google OAuth with a full-page redirect. This keeps the
 * authentication flow in the same browsing context as the PWA, so
 * session cookies set by the callback are available to the app.
 *
 * The popup-based approach failed on mobile PWAs because the popup
 * is a separate context — cookies set there never reached the PWA's
 * main window, causing the middleware to see no session and bounce
 * the user back to the login screen.
 */
export async function signInWithGoogle(next = '/'): Promise<void> {
  const supabase = getSupabaseBrowserClient();

  const redirectUrl = `${window.location.origin}/api/auth/callback?next=${encodeURIComponent(next)}`;

  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: redirectUrl,
    },
  });

  if (error) throw new Error(error.message);

  // signInWithOAuth without skipBrowserRedirect navigates the current
  // page to Google, so code below this point never executes.
}
